import { initUser } from "./models";

//export const apiUrl = "https://localhost:5001/api";
export const apiUrl = "/api";
//export const apiUrl = "https://www.qujunzhi.com/api"

export const loginInfo = {token:'',user:initUser};